module.exports = __webpack_public_path__ + "static/media/girl-3rd.27a002cd.png";